import { FieldProps } from '@rjsf/utils';

import HandlebarFormControl from 'dashboard/components/HandlebarFormControl';
import { filterErrorsForField } from 'dashboard/components/WorkflowControlPanel/StepConfigAction/rjsf/utils';
import { HandlebarsFieldType } from 'dashboard/models/workflow-schema';

export function HandlebarsField({
  idPrefix,
  idSeparator,
  disabled,
  name,
  formData,
  formContext,
  onChange,
  uiSchema,
}: FieldProps) {
  const id = idPrefix ? [idPrefix, name].join(idSeparator) : name;
  const errorsForField = filterErrorsForField(formContext.errorsForStep, id);
  const rawType = uiSchema?.['ui:options']?.type;
  let type: 'input' | 'text-area' | 'code';
  if (typeof rawType !== 'string') {
    type = 'input';
  } else if (rawType !== 'input' && rawType !== 'text-area' && rawType !== 'code') {
    type = 'input';
  } else {
    type = rawType;
  }

  return (
    <HandlebarFormControl
      id={id}
      size='md'
      type={type}
      value={formData}
      editable={!disabled}
      jsonSchema={formContext.jsonSchema}
      tokensToDisplayValue={formContext.tokensToDisplayValue}
      allowedTypes={uiSchema?.['ui:options']?.allowedFieldTypes as HandlebarsFieldType[]}
      hasError={errorsForField.length > 0}
      updateValue={(value) => onChange(value === '' ? undefined : value)}
    />
  );
}
